import { virtualvisit } from '@organisms/virtualvisit';
import { calendly } from '@molecules/calendly';
import { contact } from './offer/contact';
import { contactSchedule } from './offer/contact-schedule';

/**
 * Init Vues, and check if el exist,
 * to avoid warnings when el is not present
 */
export const vueInit = () => {
  // init virtualvisit
  if (document.querySelector('.virtualvisit') !== null) {
    virtualvisit();
  }
  if (document.querySelector('.rdv') !== null) {
    calendly();
  }

  if (document.querySelector('.contact-completion') !== null) {
    contact();
  }

  if (document.querySelector('.contact-schedule') !== null) {
    contactSchedule();
  }
};
